import { Button, FormControl, Grid, MenuItem, TextField } from "@mui/material"
import { DownloadCloud } from 'react-feather'

import { FileManagerInput } from '../../../../../../../common'


const acceptConfiguration = {
    'image/jpeg': ['.jpeg', '.jpg'],
    'image/png': ['.png'],
    'image/webp': ['.webp']
}

export const SlipSection = ({ useFetchInit, readOnlyMode }) => {

    const {
        Forms,
        Actions
    } = useFetchInit

    const { FormScreen } = Forms
    const { formState, onInputChange, onDropZoneAcceptedFilesChange, onDropZoneRejectionsFilesChange } = FormScreen

    const { handleClickDownloadImage } = Actions

    const sectionReadOnly = readOnlyMode && formState.aprobacion_check !== 'Pago Aprobado'

    return (
        <>  
            <div className="pt-4"></div>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="numero_comprobante"> * Número de DTE</label>
                        <TextField
                            id='numero_comprobante'
                            name='numero_comprobante'
                            value={ formState.numero_comprobante } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Número de DTE'
                            type='text'
                            variant={sectionReadOnly? 'filled': 'outlined'}
                            hiddenLabel
                            InputProps={{
                                readOnly: sectionReadOnly 
                            }}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="numero_serie_factura"> * Número de Serie</label>
                        <TextField
                            id='numero_serie_factura'
                            name='numero_serie_factura'
                            value={ formState.numero_serie_factura } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Número de Serie'
                            type='text'
                            variant={sectionReadOnly? 'filled': 'outlined'}
                            hiddenLabel
                            InputProps={{
                                readOnly: sectionReadOnly 
                            }}
                        />
                    </FormControl>
                </Grid>
                {(sectionReadOnly)&&(
                    <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                        <FormControl fullWidth>
                            <label htmlFor="dowload-boleta">* Boleta de Deposito</label>
                            <Button
                                startIcon={<DownloadCloud/>}
                                color='success'
                                variant="contained"
                                onClick={
                                    (event) => handleClickDownloadImage(
                                        formState.attachments[0].attachment_originalname,
                                        formState.attachments[0].attachment_path
                                    )
                                }
                                sx={{textDecoration: 'none', paddingTop: 1}}
                                disabled={(formState.attachments.length === 0)}
                            >
                                Descargar
                            </Button>
                        </FormControl>
                    </Grid>
                )}
                
                {/* <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="numero_comprobante"> * Subir Archivo</label>
                        <span>----- SECCIÓN PARA CARGAR IMAGEN ----</span>
                    </FormControl>
                </Grid> */}
            </Grid>
            {(!sectionReadOnly)&&(
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ marginBottom: 2, marginTop: 2 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>   
                        <FormControl fullWidth>
                            <label htmlFor="images">* Boleta de Deposito</label>
                            <FileManagerInput
                                acceptedFiles={formState.acceptedFiles}
                                fileRejections={formState.fileRejections}
                                NameId='images'
                                typeFiles='IMG'
                                maxFiles={1}
                                accept={acceptConfiguration}
                                setAcceptedFiles={onDropZoneAcceptedFilesChange}
                                setFileRejections={onDropZoneRejectionsFilesChange}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            )}
        </>
    )
}
